import {AttributeManifest, AttributeManifestEntry, ImprovementManifestEntry} from "../models/attributeManifest.model";
import {Metadata, RemoteConstantsModel} from "../models/remoteConstants.model";

// The Client's Improvement reward (ImprovementUpgrade) and the parameter naming which improvement it grants.
const IMPROVEMENT_REWARD_TYPE = 'ImprovementUpgrade';
const IMPROVEMENT_TYPE_PARAM = 'improvementType';

// The improvement a City Reward grants, or undefined for a reward of another kind (or a
// manifest without the Improvements section). Matched by name: the reward stores the
// enum member's index, and the enum's members are the improvements' names.
export function improvementOfReward(
    reward: Pick<Metadata, 'values'>,
    entry: AttributeManifestEntry | undefined,
    manifest: AttributeManifest | undefined,
): ImprovementManifestEntry | undefined {
    if (entry?.TypeName !== IMPROVEMENT_REWARD_TYPE)
        return undefined;

    const param = entry.Parameters.find(p => p.Name === IMPROVEMENT_TYPE_PARAM);
    const index = reward.values?.[IMPROVEMENT_TYPE_PARAM] ?? Number(param?.DefaultValue ?? 0);
    const name = param?.EnumValues?.[index];
    return manifest?.Improvements?.find(i => i.Name === name);
}

// The name keys of an enum's members when every member is an improvement (the Improvement reward's
// improvementType), so a dropdown can show the names authored under City Improvements; else undefined.
export function improvementNameKeys(members: string[], manifest: AttributeManifest | undefined): string[] | undefined {
    const keys = members.map(member => manifest?.Improvements?.find(i => i.Name === member)?.NameKey);
    return keys.every((key): key is string => key !== undefined) ? keys : undefined;
}

// The image a metadata entry (a reward) shows as its own icon: the one its single-slot pack points
// at, else one uploaded under its uid; undefined when it has none.
export function ownIconKey(state: RemoteConstantsModel, uid: string): string | undefined {
    return state.imagePacks?.[uid]?.[0]?.[0]
        ?? (state.images && uid in state.images ? uid : undefined);
}
